<template>
    <div class="timeline-loading-overlay">
        <LoadingSpinner />
        <span class="loading-text">Loading data</span>
    </div>
</template>

<script setup lang="ts">
import LoadingSpinner from '@/components/Commons/UI/molecules/LoadingSpinner.vue';

defineOptions({ name: 'TimelineLoadingOverlay' });
</script>

<style scoped>
.timeline-loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.95);
    z-index: 1000;
    min-height: 400px;
    gap: 12px;
}

.loading-text {
    font-size: 16px;
    color: #495057;
    font-weight: 500;
}
</style>
